module.exports = __webpack_public_path__ + "static/Banner02-4432d35c412ad7cf05a621ef48784291.png";